import PrizeCategories from './components/PrizeCategories';
export default PrizeCategories;